import { z } from "zod";

export const lsFontFamilySchema = z.enum(["normal", "serif", "sans_serif"]);

export type LSFontFamily = z.infer<typeof lsFontFamilySchema>;
